// src/components/common/EmailVerificationBanner.jsx
// ✅ Banner non bloccante — l'utente può usare l'app ma viene avvisato
import React, { useState } from 'react';
import { EnvelopeIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContext';
import axiosConfig from '../../api/axiosConfig';
import toast from 'react-hot-toast';

const EmailVerificationBanner = () => {
    const { user } = useAuth();
    const [dismissed, setDismissed] = useState(false);
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    // Non mostrare se email già verificata, utente non loggato o banner chiuso
    if (!user || user.emailVerified || dismissed) return null;

    const handleResend = async () => {
        setSending(true);
        try {
            await axiosConfig.post('/auth/resend-verification');
            setSent(true);
            toast.success('Email di verifica inviata!');
        } catch {
            toast.error('Errore nell\'invio. Riprova tra qualche minuto.');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5">
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 flex-wrap">
                <div className="flex items-center gap-2.5">
                    <EnvelopeIcon className="w-4 h-4 text-amber-600 flex-shrink-0" />
                    <p className="text-sm text-amber-800">
                        <span className="font-semibold">Verifica la tua email</span>
                        {' '}— Controlla la tua casella <strong>{user.email}</strong> e clicca il link di conferma.
                    </p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {!sent ? (
                        <button onClick={handleResend} disabled={sending}
                            className="text-xs font-semibold text-amber-700 hover:text-amber-900 underline underline-offset-2 disabled:opacity-50 transition">
                            {sending ? 'Invio...' : 'Rinvia email'}
                        </button>
                    ) : (
                        <span className="text-xs text-emerald-600 font-semibold">✅ Email inviata</span>
                    )}
                    <button onClick={() => setDismissed(true)}
                        className="p-1 text-amber-500 hover:text-amber-700 hover:bg-amber-100 rounded-lg transition">
                        <XMarkIcon className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmailVerificationBanner;